import { VolumeDiscountRepository } from "public/repository/volume-discount.repository";

/**
 * @type {{name: string, timestamp: number}}
 */
const metadata = {
  name: "add-settings-to-volume-discount",
  timestamp: new Date("2025-07-19").getTime(),
};

/**
 * Add missing settings to volume discounts
 * @param {Object} args
 * @param {Object} args.settings
 * @param {string} args.settings.namespace
 */
async function migrate({ settings }) {
  const volumeDiscountRepository = new VolumeDiscountRepository(settings);
  const volumeDiscounts = await volumeDiscountRepository.getAll();

  if (volumeDiscounts.items.length <= 0) {
    return;
  }

  if (volumeDiscounts.items.length >= 500) {
    console.log(
      `migrate:Volume Discounts collection is too large to migrate`,
      metadata.name
    );
    return;
  }

  for (const volumeDiscount of volumeDiscounts.items) {
    console.log(metadata.name, volumeDiscount, "Checking volume discount");

    if (
      volumeDiscount.settings &&
      Object.keys(volumeDiscount.settings).length > 0
    ) {
      console.log(
        metadata.name,
        volumeDiscount._id,
        "Volume discount already has settings"
      );

      continue;
    }

    console.log(
      metadata.name,
      volumeDiscount._id,
      "Adding missing settings to volume discount"
    );

    await volumeDiscountRepository.update({
      ...volumeDiscount,
      settings: {
        allowMultipleVariationSelection: true,
      },
    });
  }
}

export default { metadata, migrate };
